import { put, call } from 'redux-saga/effects'

import { snackbarActions } from 'reduxModules/actions/SnackbarActions'

import { rsf, firestore } from '../../firebase'

const QUERY_LIMIT = 10000

export function* getAllBookingsSaga(action) {
  const { responseSuccess, responseFailure, data: startAfter } = action

  try {
    const query = startAfter
      ? firestore.collection(`bookings`)
        .orderBy("departureTimestamp", "asc")
        .startAfter(startAfter)
        .limit(QUERY_LIMIT)
      : firestore.collection(`bookings`)
        .orderBy("departureTimestamp", "asc")
        .limit(QUERY_LIMIT)

    const res = yield call(rsf.firestore.getCollection, query)

    if (!res.empty) {
      const bookings = []

      yield res.forEach(booking => bookings.push({ id: booking.id, ...booking.data() }))

      const isComplete = bookings.length !== QUERY_LIMIT

      yield put(responseSuccess({
        bookings,
        isComplete
      }))
    }
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час завантаження замовлень!'
    }))
  }
}



// WEBPACK FOOTER //
// ./src/reduxModules/sagas/PlaygroundSagas.js